<template>
  <div>
    <base-header type="gradient-info" class=" header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="display-2 text-white">{{league.Name}}</h1>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <card>
            <div slot="header" class="row d-flex align-items-center">
              <div class="col-lg-9">
                <h3 class="mb-0">Enter Scores</h3>
              </div>
              <div class="col-lg-3">
                <Multiselect
                  :options="weeks"
                  trackBy="id"
                  :customLabel="weekLabel"
                  v-model="selectedWeekModel"
                  selectLabel=""
                  deselectLabel=""
                />
              </div>
            </div>

            <PlayerScoreCard
              class="player"
              v-for="profile in profiles"
              :key="profile.id"
              :profile="profile"
              :week="selectedWeek"
              @saved="refreshLists"
              ref="scorecard"
              :league="league"
            />

            <MixedTeamScorecard
              class="player"
              v-for="team in teams"
              :key="team.id"
              :team="team"
              :week="selectedWeek"
              @saved="refreshLists"
              ref="scorecard"
              :league="league"
            />

            <div class="row">
              <div class="col-lg-12 text-right">
                <base-button
                  type="success"
                  @click="saveAllScores"
                >
                  Save All
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.changeWeekConfirm"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>
          You have unsaved changes for Week {{selectedWeekNumber}}.
          Would you like to proceed without saving?
        </p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="discardAndContinue"
        >
          Discard & Continue
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="selectedWeekModel = selectedWeek; modals.changeWeekConfirm = false;"
        >
          Stay
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment';
import PlayerScoreCard from '@/components/PlayerScoreCard.vue';
import MixedTeamScorecard from '@/components/MixedTeamScorecard.vue';

export default {
  name: 'AddFlexLeagueScores',
  components: {
    Multiselect,
    PlayerScoreCard,
    MixedTeamScorecard,
  },
  props: {
    id: [String, Number],
    mixed: Boolean,
  },
  data() {
    return {
      selectedWeek: null,
      selectedWeekModel: null,
      league: {
        id: '',
      },
      weeks: [],
      profiles: [],
      teams: [],
      modals: {
        changeWeekConfirm: false,
      },
    };
  },
  mounted() {
    this.refreshLists()
      .then(() => {
        this.selectedWeek = this.currentWeek;
        this.selectedWeekModel = this.currentWeek;
      });
  },
  computed: {
    currentWeek() {
      let theWeek = null;
      this.weeks.forEach((week) => {
        if (moment(week.Start).isBefore(moment())
          && moment(week.Start).add(7, 'days').isAfter(moment())
        ) {
          theWeek = week;
        }
      });
      if (theWeek === null) {
        let index = 0;
        this.weeks.forEach((week) => {
          if (moment(week.Start).isAfter(moment()) && index > 0) {
            theWeek = this.weeks[index - 1];
          }
          index += 1;
        });
      }
      if (theWeek === null) {
        [theWeek] = this.weeks;
      }

      return theWeek;
    },
    selectedWeekNumber() {
      return this.selectedWeek !== null ? this.selectedWeek.WeekNumber : null;
    },
  },
  watch: {
    selectedWeekModel() {
      if (this.areAllScoresSaved()) {
        this.selectedWeek = this.selectedWeekModel;
      } else if (this.selectedWeek !== this.selectedWeekModel) {
        this.modals.changeWeekConfirm = true;
      }
    },
  },
  methods: {
    discardAndContinue() {
      this.$refs.scorecard.forEach((card) => {
        if (card.status.text === 'UNSAVED' || card.status.text === 'INCOMPLETE') {
          card.discard();
        }
      });
      this.modals.changeWeekConfirm = false;
      this.selectedWeek = this.selectedWeekModel;
    },
    areAllScoresSaved() {
      let result = true;
      if (!this.$refs.scorecard) {
        return result;
      }
      this.$refs.scorecard.forEach((card) => {
        if (card.status.text === 'UNSAVED' || card.status.text === 'INCOMPLETE') {
          result = false;
        }
      });
      return result;
    },
    saveAllScores() {
      this.$refs.scorecard.forEach((card) => {
        if (card.status.text === 'UNSAVED') {
          card.save();
        }
      });
    },
    refreshLists() {
      this.getLeague();
      this.getProfiles();
      this.getTeams();
      return this.getWeeks();
    },
    weekLabel(week) {
      return `Week ${week.WeekNumber} - ${week.course ? week.course.Name : 'No Course'}`;
    },
    getLeague() {
      return this.axios
        .get(`/leagues/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.league = response.data;
          this.league.weeks = this.league.weeks.sort((a, b) => {
            return parseInt(a.WeekNumber, 10) - parseInt(b.WeekNumber, 10);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getWeeks() {
      return this.axios
        .get(`/weeks?league_eq=${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.weeks = response.data;
          this.weeks = this.weeks.sort((a, b) => {
            return parseInt(a.WeekNumber, 10) - parseInt(b.WeekNumber, 10);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTeams() {
      return this.axios
        .get(`/teams?league_eq=${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.teams = response.data;
          this.teams = this.teams.sort((a, b) => {
            if (b.Name > a.Name) {
              return -1;
            }
            if (b.Name < a.Name) {
              return 1;
            }
            return 0;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getProfiles() {
      return this.axios
        .get(`/profiles?league_eq=${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.profiles = response.data;
          this.profiles = this.profiles.sort((a, b) => {
            if (b.user.Name > a.user.Name) {
              return -1;
            }
            if (b.user.Name < a.user.Name) {
              return 1;
            }
            return 0;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  .player{
    margin-bottom: 1rem;
  }
  .avatar{
    width: 60px;
    height: 60px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
